import './index.less';

import { logCommonView, webToolsLink } from '@/lib/service';
import { useMemo, useState } from 'react';

import { EventSource } from '@/shared/constants/event';
import HeaderMenu from '../../HeaderMenu';
import Image from 'next/image';
import Link from 'next/link';
import { NavMenuType } from '@/types/layout';
import classNames from 'classnames';
import { useRouter } from 'next/router';

interface IProps {
  isLarge?: boolean;
  isFullLength?: boolean;
  goToPreviewFlow: () => void;
}

export default function DesktopHeader({ isLarge = false, isFullLength = false, goToPreviewFlow }: IProps) {
  const { pathname } = useRouter();

  const [activeMenu, setActiveMenu] = useState<NavMenuType>(null);

  const menu = useMemo(() => {
    return (
      <HeaderMenu
        goToPreviewFlow={goToPreviewFlow}
        activeMenu={activeMenu}
        closeActiveMenu={() => {
          setActiveMenu(null);
        }}
      />
    );
  }, [activeMenu, goToPreviewFlow]);

  return (
    <div
      className={classNames('pietra-header-container', {
        large: isLarge,
        'full-length': isFullLength,
      })}
    >
      {menu}
      <div className="header-left">
        <Link href={'/'} className="logo">
          <Image
            width={80}
            height={21}
            src="/images/header/small-logo.svg"
            alt="Pietra"
            title="Pietra"
            loading="eager"
          />
        </Link>

        <span
          className={classNames('custom-menu-trigger', { active: activeMenu === NavMenuType.E_COMMERCE_SUITE })}
          onMouseEnter={(e) => {
            e.preventDefault();
            setActiveMenu(NavMenuType.E_COMMERCE_SUITE);
          }}
        >
          <span>Products</span>
          <div className="dropdown-arrow" />
        </span>
        <span
          className={classNames('custom-menu-trigger', { active: activeMenu === NavMenuType.PLATFORM })}
          onMouseEnter={(e) => {
            e.preventDefault();
            setActiveMenu(NavMenuType.PLATFORM);
          }}
        >
          <span>Solutions</span>
          <div className="dropdown-arrow" />
        </span>
        <span
          className={classNames('custom-menu-trigger', { active: activeMenu === NavMenuType.RESOURCES })}
          onMouseEnter={(e) => {
            e.preventDefault();
            setActiveMenu(NavMenuType.RESOURCES);
          }}
        >
          <span>Resources</span>
          <div className="dropdown-arrow" />
        </span>
        <Link
          key="help"
          className={classNames('help', {
            active: pathname.startsWith('/help-videos'),
          })}
          href="/help-videos"
          onMouseEnter={(e) => {
            e.preventDefault();
            setActiveMenu(null);
          }}
          onClick={() => {
            logCommonView(EventSource.HELP_VIDEOS, 'CLICK');
          }}
        >
          Help Videos
        </Link>
        <Link
          key="pricing"
          className={classNames('pricing', {
            active: pathname.startsWith('/plans-and-pricing'),
          })}
          href="/plans-and-pricing"
          onMouseEnter={(e) => {
            e.preventDefault();
            setActiveMenu(null);
          }}
          onClick={() => {
            logCommonView(EventSource.PRICING, 'CLICK');
          }}
        >
          Pricing
        </Link>
      </div>
      <div className="header-right">
        <div className="nav-button demo" onClick={goToPreviewFlow} key="preview-pietra">
          <span
            className="preview-pietra"
            onMouseEnter={(e) => {
              e.preventDefault();
              setActiveMenu(null);
            }}
          >
            Book demo
          </span>
        </div>

        <Link href={webToolsLink()} target="_blank" className="nav-button signin">
          Sign in
        </Link>

        <Link className="button-wrap" href="/sell-on-pietra/register">
          Start for free
        </Link>
      </div>
    </div>
  );
}
